import React, { Component } from 'react';

import { Offcanvas, Row, Col, Card } from 'react-bootstrap';

import CommonButton from '../components/CommonButton';
import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonFile from '../components/CommonFile';

import CustomDatePicker from "../components/CommonDatePicker";

/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import SimpleBar from 'simplebar-react';
class InputEB04DataCourse extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: new Date()
        };
    }
    
    handleDateChange = (date) => {
        this.setState({ selectedDate: date });
    }
    
    componentDidUpdate = async (prevProps) => {
        // if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
        //     await this.prepareInputs();
        // }
    }
    
    // prepareInputs = async () => {
    //     const { URL, Action, Inputs, onUpdateState, UserCookie } = this.props;
    //     const isUpdateMode = Action.Mode === 'update';

    //     let updatedInputs = fn.setRequiredPrimaryKey(Inputs, isUpdateMode);
        
    //     if (Action.Mode === "new") {
    //         if (['2', '3', '4', '5'].includes(UserCookie.types)) {
    //              updatedInputs.types = {
    //                 ...updatedInputs.types,
    //                 value: UserCookie.types,
    //                 };

    //         // }else if (UserCookie.types === "2") {
    //         //     updatedInputs.types = {
    //         //     ...updatedInputs.types,
    //         //     value: "1"
    //         //     };                
    //         //     updatedInputs.academy_id = {
    //         //     ...updatedInputs.academy_id,
    //         //     value: UserCookie.academy_id,
    //         //     };
                
    //         }else if (['0', '1'].includes(UserCookie.types)) {
    //             updatedInputs.types = {
    //             ...updatedInputs.types,
    //             value: "1"
    //             };
    //         }
    //         updatedInputs.status = {
    //             ...updatedInputs.status,
    //             value: "0"
    //             };
    //         updatedInputs.news_type = {
    //             ...updatedInputs.news_type,
    //             value: "0"
    //             };

    //     }

    //     onUpdateState('Inputs', updatedInputs);
    // }

    toggleOwnerType = (index) => {
        const { Inputs, onUpdateState } = this.props;

        const getUpdatedField = (fieldKey, { value, required }) => ({
            ...Inputs[fieldKey],
            value: value !== undefined ? value : Inputs[fieldKey].value,
            validator: {
                ...Inputs[fieldKey].validator,
                required: required !== undefined ? required : Inputs[fieldKey].validator.required,
            },
            error: {
                ...Inputs[fieldKey].error,
                status: null,
                msg: '',
            }
        });

        const fieldUpdatesByIndex = {
            '0': {
                academy_id: { value: '', required: false },
                enterprise_id: { value: '', required: false },
                user_id: { value: '', required: false }
            },
            '1': {
                academy_id: { required: true },
                enterprise_id: { value: '', required: false },
                user_id: { value: '', required: false }
            },
            '2': {
                academy_id: { required: true },
                enterprise_id: { value: '', required: false },
                user_id: { value: '', required: true }
            },
            '3': {
                enterprise_id: { required: true },
                academy_id: { value: '', required: false },
                user_id: { value: '', required: true }
            },
            '4': {
                enterprise_id: { required: true },
                academy_id: { value: '', required: false },
                user_id: { value: '', required: true }
            },
            '5': {
                enterprise_id: { required: true },
                academy_id: { value: '', required: false },
                user_id: { value: '', required: true }
            }
        };
    
        const updates = fieldUpdatesByIndex[index] || {};
        
        const updatedInputs = {
            ...Inputs,
            ...Object.fromEntries(
                Object.entries(updates).map(
                    ([fieldKey, config]) => [fieldKey, getUpdatedField(fieldKey, config)]
                )
            )
        };
    
        onUpdateState('Inputs', updatedInputs);
    };

    getFilteredUsers = () => {
        const { Inputs, Masterbase, UserCookie } = this.props;
        const external_user = Masterbase?.external_user || [];
        const typeValue = UserCookie?.types;
                                                // disabled={!['0', '1'].includes(UserCookie.types)}
      
        return external_user;
        // if (typeValue === '0') {
        //   return users.filter(u => ['0', '1'].includes(u.types));
        // }
      
        // if (typeValue === '1') {
        //   const academyId = Inputs.academy_id?.value;
        //   return users.filter(u => u.types === '1' && u.academy_id === academyId);
        // }
    
        // if (typeValue === '2') {
        //   const academyId = Inputs.academy_id?.value;
        //   return users.filter(u => u.types === '2' && u.academy_id === academyId);
        // }
      
        // if (typeValue === '3') {
        //   const enterpriseId = Inputs.enterprise_id?.value;
        //   return users.filter(u => u.types === '3' && u.enterprise_id === enterpriseId);
        // }
    
        if (typeValue === '4') {
          return external_user.filter(u => u.id === UserCookie.id);
        }
    
        // if (typeValue === '5') {
        //   const enterpriseId = Inputs.enterprise_id?.value;
        //   return users.filter(u => u.types === '3' && u.enterprise_id === enterpriseId);
        // }
      
        // return [];
    };
      
    
    render = () => {
        let props = this.props;

        let { onInputChange, onCloseAlert, onSubmit, onDiscardSubmit, onPreviewFile, onDeleteFile, onRegisterEnrollKey } = props;

        let { App, Action, Inputs, InputGroup, Masterbase, Operation, UserCookie } = props;

        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;

        let isLoading = Action.Loading.submit;

        return (
                <Offcanvas 
                    show={show}
                    placement="end" 
                    style={{ '--bs-offcanvas-width':  window.innerWidth < 768 ? '80vw' : '50vw' }}
                    scroll={true}
                    backdrop={Submit ? "static" : true}
                    onHide={(e) => props.onClose(e)}
                >
                    <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                        <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                    </Offcanvas.Header>

                    <Offcanvas.Body className="custom-offcanvas-body">
                        
                        <CommonAlert 
                            alert={Action.Alert} 
                            callback={(e) => onCloseAlert(e)}
                        />
                        
                        <SimpleBar id="inputs" className="simple-bar-input">
                            
                            <Row className="mt-3"> 
                                <Col md={12}>
                                    <CommonSelect
                                        element="Inputs"
                                        input={Inputs.external_id}
                                        option={{source: 'db', data: this.getFilteredUsers()}}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                            disabled={!['0','1','2'].includes(UserCookie.types)}
                                    />
                                </Col>
                            </Row> 
                            <Row className="mt-3"> 
                                <Col md={12}>
                                    <CommonInput
                                        element="Inputs"
                                        input={Inputs.enroll_key}
                                        hr={false}
                                        callback={(e, element) => onInputChange(e, element)} 
                                    />
                                </Col>
                            </Row>                            

                        </SimpleBar>

                    </Offcanvas.Body>
                    
                    <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">
                        
                        <CommonLoadingBar isLoading={isLoading} />

                        <div className="d-flex justify-content-end mt-2">
                            <CommonButton 
                                task={mode} 
                                disabled={isLoading ? true : Submit ? false : true}
                                callback={async (e) => { 
                                    // console.log("this.state.Inputs.external_id.value",Inputs?.external_id?.value);                                    
                                    await onRegisterEnrollKey({id: Inputs.external_id.value}); 
                                    // await onSubmit(e);
                                }} 
                            />

                            {Action.Mode === 'new' && (
                                <CommonButton 
                                    task="discard" 
                                    inlineClass="ms-1" 
                                    disabled={isLoading} 
                                    callback={(e) => onDiscardSubmit(false)} 
                                />
                            )}
                        </div>
                    </div>
                </Offcanvas>      
        )
    }
}

export default InputEB04DataCourse;